import type { TersaImageModel } from '../types';
import { providers } from '../../providers';
import { wavespeed } from '../wavespeed';

// 系数
const COST_FACTOR = 1.5;

export const nvidiaModels: Record<string, TersaImageModel> = {
    'cosmos-3-super': {
        chef: providers.nvidia,
        providers: [
            {
                ...providers.nvidia,
                model: wavespeed.image('nvidia/cosmos-3-super/text-to-image'),
                getCost: () => {
                    return 0.04 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '4x3', '3x4', '1x1'],
                resolutions: [],
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i'],
        supportsEdit: false,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};